module.exports = __webpack_public_path__ + "img/home_ic_monitoring.efdd7447.png";